module.exports = __webpack_public_path__ + "static/img/img6.906ae80d.png";